import React, { useState, useEffect } from "react";
import pozorista from "./Data/pozorista.json";
import muzeji from "./Data/muzeji.json";
import biblioteke from "./Data/biblioteke.json";
import bioskopi from "./Data/bioskopi.json";
import SelectDropdown from "./Components/SelectDropdown.js";
import SearchInput from "./Components/SearchInput.js";
import "./Styles/App.css";
import Chart from "react-apexcharts";
import { options } from "./Components/SelectDropdown.js";
import Map from "./Components/Map";
import ChartCI from "./Components/ChartCI";
import logo from "../src/assets/logo.png";
const App = () => {
  const data = [...pozorista, ...muzeji, ...biblioteke, ...bioskopi];
  const [value, setValue] = useState("");
  const [selected, setSelected] = useState(options);
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = () => {
    const section = document.getElementById("help-section");
    section.scrollIntoView({ behavior: "smooth" });
  };

  const getSearchValue = (value) => {
    setValue(value);
  };

  const getSelected = (value) => {
    setSelected(value);
  };

  const p = data.filter(({ tip_ustanove, mesto }) => {
    return (
      selected.some(({ value }) => value === tip_ustanove) &&
      mesto.includes(value)
    );
  });

  const count = p.reduce((acc, curr) => {
    acc[curr.tip_ustanove] = (acc[curr.tip_ustanove] || 0) + 1;
    return acc;
  }, {});

  const pa = Object.entries(count).map(([value, count]) => ({
    value,
    count,
  }));

  const niz = pa.map(({ count }) => count).filter((count) => count !== 0);
  const i = pa.map(({ value }) => value);

  useEffect(() => {}, [selected, value]);

  return (
    <div className="container">
      <div className="project-title">
        <img src={logo} /> <h2>Установе културе у Републици Србији</h2>
      </div>
      <div className=" row inputs">
        <div className="col-7 select-dropdown">
          <SelectDropdown getVal={getSelected} selected={selected} />
        </div>
        <div className="col-4 search-input">
          <SearchInput func={getSearchValue} isOpenAC={isOpen} />
        </div>
      </div>
      <div className="row ">
        <div className="col question">
          <span onClick={scrollToSection}>
            Како унети назив града на латиници ?{" "}
            <a href="#help-section">Сазнај више</a>
          </span>
        </div>
      </div>

      <div className="row mapa">
        <Map p={p} />
      </div>
      <div className="chart-section row">
        <ChartCI niz={niz} i={i} />
      </div>
      <div>
        <hr className="hr" />{" "}
      </div>
      <div id="help-section" className="help">
        <h2>Како унети назив града на латиници ?</h2>
        <p className="convert-desc">
          Назив града за претрагу установа културе се примарно уноси ћирилицом
          како би се очувала језичка и културна традиција повезана са српским
          језиком. Међутим, разумемо да постоје корисници који желе да уносе
          назив града латиницом, па смо омогућили конверзију унетог текста из
          латинице у ћирилицу. <br />
          Важно је напоменути да се већина слова конвертује слово за слово (нпр.
          латинично слово L ће се приликом уноса у поље за назив града
          конвертовати у ћирилично слово Л). Међутим, постоје и слова која се
          исписују помоћу комбинације два слова.
          <br />
          Приликом уноса комбинације слова, систем ће аутоматски конвертовати ту
          комбинацију у слово које та комбинација представља.
          <br /> Ево неколико примера:
        </p>
        <ul>
          <li>Слово "ч" се представља коришћењем комбинације слова "цц"</li>
          <li>Слово "ћ" се представља коришћењем комбинације слова "цј"</li>
          <li>Слово "ђ" се представља коришћењем комбинације слова "дј"</li>
          <li>Слово "љ" се представља коришћењем комбинације слова "лј"</li>
          <li>Слово "њ" се представља коришћењем комбинације слова "нј"</li>
          <li>Слово "ш" се представља коришћењем комбинације слова "сс"</li>
          <li>Слово "џ" се представља коришћењем комбинације слова "дз"</li>
          <li>Слово "ж" се представља коришћењем комбинације слова "зз"</li>
        </ul>
        <p className="convert-desc" style={{ margin: "20px 0" }}>
          Наш циљ је да обезбедимо приступачност и подршку свим корисницима који
          желе да претражују установе културе у Републици Србији. Стога смо
          омогућили конверзију назива града из латинице у ћирилицу како бисмо
          задовољили различите потребе корисника и омогућили да истражују богату
          културну баштину Републике Србије.
        </p>
      </div>
    </div>
  );
};

export default App;
